import { createSlice } from "@reduxjs/toolkit";

export const questionnaireSlice = createSlice({
  name: "questionnaire",
  initialState: {
    action: ""
  },
  reducers: {
    setAction: (state, action) => {
      state.action = action.payload;
    }
  }
});

export const { setAction } = questionnaireSlice.actions;

export default questionnaireSlice.reducer;